import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import {BuddyListOptionWithIcon} from "~/operatorApplication/vue/dialogs/buddyList/group/BuddyListInterface";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";


const __default__ = {
    name: "BuddyListItemIcons"
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    optionsWithIcons: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (__props.optionsWithIcons.length)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.optionsWithIcons, (item, key) => {
          return _withDirectives((_openBlock(), _createBlock(FontAwesomeIcon, {
            key: key,
            icon: item.option.icon,
            "icon-style": item.option.iconStyle,
            class: "first-line-icon icon",
            style: _normalizeStyle({color: item.option.iconColor ? `${item.option.iconColor} !important` : null })
          }, null, 8, ["icon", "icon-style", "style"])), [
            [_directive_my_tooltip, {text: item.tooltip, delay: 500}]
          ])
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})